import React, { useState, useEffect } from 'react'
import BackLogo from '../../../../../../images/rewampimages/Chevron.png'
import Loader from '../../../../../presentationals/Loader/Loader.component';
import PiePage from '../../CommonComponents/PiePage.component'
import InputField from '../../CommonComponents/InputMUI'
import SelectField from '../../CommonComponents/SelectMUI';
import { SaveHubTargetAssignByData } from '../ActionCreator';
import Popup from '../../../../../presentationals/Popup/Popup.component'
import moment from 'moment';

export default function Add({ editData, handleTab,ListData }) {
    const [loader, setLoader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: '' })
    const [errors, setErrors] = useState([])
    const [objectDataNew, setobjectDataNew] = useState({
        targetStartDate: moment().format("YYYY-MM-DD"),
        targetEndDate: moment().format("YYYY-MM-DD"),
        milestone1Date: moment().format("YYYY-MM-DD"),
        milestone2Date: moment().format("YYYY-MM-DD"),
        milestone3Date: moment().format("YYYY-MM-DD"),
        milestone1Percentage: "",
        milestone2Percentage: "", milestone3Percentage: "",
        totalTarget: "", l2Target: "",
        l3Target: "",
        l5Target: "",
        batteryTarget: "",
    })


    useEffect(() => {
        if (editData?.id || editData?.hubId) {
            setobjectDataNew({
                targetStartDate: editData?.targetStartDate || moment().format("YYYY-MM-DD"),
                targetEndDate: editData?.targetEndDate || moment().format("YYYY-MM-DD"),
                milestone1Date: editData?.milestone1Date || moment().format("YYYY-MM-DD"),
                milestone2Date: editData?.milestone2Date || moment().format("YYYY-MM-DD"),
                milestone3Date: editData?.milestone3Date || moment().format("YYYY-MM-DD"),
                milestone1Percentage: editData?.milestone1Percentage || "",
                milestone2Percentage: editData?.milestone2Percentage || "", milestone3Percentage: editData?.milestone3Percentage || "",
                totalTarget: editData?.totalTarget || "", l2Target: editData?.l2Target || "",
                l3Target: editData?.l3Target || "",
                l5Target: editData?.l5Target || "",
                batteryTarget: editData?.batteryTarget || "",
            })

        } else {
            setobjectDataNew({
                targetStartDate: moment().format("YYYY-MM-DD"),
                targetEndDate: moment().format("YYYY-MM-DD"),
                milestone1Date: moment().format("YYYY-MM-DD"),
                milestone2Date: moment().format("YYYY-MM-DD"),
                milestone3Date: moment().format("YYYY-MM-DD"),
                milestone1Percentage: "",
                milestone2Percentage: "", milestone3Percentage: "",
                totalTarget: "", l2Target: "",
                l3Target: "",
                l5Target: "",
                batteryTarget: "",
            })
        }
    }, [editData])



    const inputChange = (e, type) => {

        setobjectDataNew((prev) => ({
            ...prev,
            [type]: e
        }))

        setErrors(prev => ({ ...prev, [type]: "" }))
    }

    const saveHandler = (type) => {
        if (type == "close") {
            handleTab("list", "")
        } else if (type == "save") {

            console.log("Form data ready to submit:", objectDataNew)
            setLoader(true)
            const obj = {
                ...objectDataNew,
                targetStartDate: moment(objectDataNew?.targetStartDate).format("DD-MM-YYYY"),
                targetEndDate: moment(objectDataNew?.targetEndDate).format("DD-MM-YYYY"),
                milestone1Date: moment(objectDataNew?.milestone1Date).format("DD-MM-YYYY"),
                milestone2Date: moment(objectDataNew?.milestone2Date).format("DD-MM-YYYY"),
                milestone3Date: moment(objectDataNew?.milestone3Date).format("DD-MM-YYYY"),
            }
            obj.hubId = ListData?.hubId,
            SaveHubTargetAssignByData(obj, callback => {
                setLoader(false)
                if (callback?.message == "success") {
                    setobjectDataNew({
                        targetStartDate: moment().format("YYYY-MM-DD"),
                        targetEndDate: moment().format("YYYY-MM-DD"),
                        milestone1Date: moment().format("YYYY-MM-DD"),
                        milestone2Date: moment().format("YYYY-MM-DD"),
                        milestone3Date: moment().format("YYYY-MM-DD"),
                        milestone1Percentage: "",
                        milestone2Percentage: "",
                        milestone3Percentage: "",
                        totalTarget: "", 
                        l2Target: "",
                        l3Target: "",
                        l5Target: "",
                        batteryTarget: "",
                    })
                    setpopup({ show: true, popupStatus: 'Target Saved Successfully' })
                    setTimeout(() => {
                        saveHandler("close")
                    }, 5000)
                } else {
                    setpopup({ show: true, popupStatus: `Error: ${callback?.error?.errorMessage || ""} ` })
                }
                removePopup()

            })
        }
    }



    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 3000)
    }
    return (
        <>
            <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center', marginLeft: '15px' }} onClick={(e) => handleTab("list", '')}>
                <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                <h5 style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>Back</h5>
            </div>

            <div className="communitySection">
                <div className='container hoverNone card'>
                    {loader ?
                        <Loader />
                        : null}

                    {
                        popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
                    }


                    <PiePage
                        totalPage={1}
                        currentPage={1}
                        heading={'Add / Update Targets'}
                    />

                    <div className='row' style={{ marginBottom: '12px' }}>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Target Start Date"
                                variant="outlined"
                                value={objectDataNew.targetStartDate}
                                name="targetStartDate"
                                id="targetStartDate"
                                type="date"
                                onChange={e => inputChange(e, 'targetStartDate')}
                                size="small" required={true}
                            />
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Target End Date"
                                variant="outlined"
                                value={objectDataNew.targetEndDate}
                                name="targetEndDate"
                                id="targetEndDate"
                                type="date"
                                onChange={e => inputChange(e, 'targetEndDate')}
                                size="small" required={true}
                            />
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Milestone 1 Date"
                                variant="outlined"
                                value={objectDataNew.milestone1Date}
                                name="milestone1Date"
                                id="milestone1Date"
                                type="date"
                                onChange={e => inputChange(e, 'milestone1Date')}
                                size="small" required={true}
                            />
                        </div>

                    </div>
                    <div className='row' style={{ marginBottom: '12px' }}>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Milestone 2 Date"
                                variant="outlined"
                                value={objectDataNew.milestone2Date}
                                name="milestone2Date"
                                id="milestone2Date"
                                type="date"
                                onChange={e => inputChange(e, 'milestone2Date')}
                                size="small" required={true}
                            />
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Milestone 3 Date"
                                variant="outlined"
                                value={objectDataNew.milestone3Date}
                                name="milestone3Date"
                                id="milestone3Date"
                                type="date"
                                onChange={e => inputChange(e, 'milestone3Date')}
                                size="small" required={true}
                            />
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Milestone 1 Percentage"
                                variant="outlined"
                                value={objectDataNew.milestone1Percentage}
                                name="milestone1Percentage"
                                id="milestone1Percentage"
                                type="text"
                                onChange={e => inputChange(e, 'milestone1Percentage')}
                                size="small" required={true}
                            />
                        </div>
                    </div>
                    <div className='row' style={{ marginBottom: '12px' }}>

                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Milestone 2 Percentage"
                                variant="outlined"
                                value={objectDataNew.milestone2Percentage}
                                name="milestone2Percentage"
                                id="milestone2Percentage"
                                type="text"
                                onChange={e => inputChange(e, 'milestone2Percentage')}
                                size="small" required={true}
                            />
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Milestone 3 Percentage"
                                variant="outlined"
                                value={objectDataNew.milestone3Percentage}
                                name="milestone3Percentage"
                                id="milestone3Percentage"
                                type="text"
                                onChange={e => inputChange(e, 'milestone3Percentage')}
                                size="small" required={true}
                            />
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Total Target"
                                variant="outlined"
                                value={objectDataNew.totalTarget}
                                name="totalTarget"
                                id="totalTarget"
                                type="number"
                                onChange={e => inputChange(e, 'totalTarget')}
                                size="small" required={true}
                            />
                        </div>
                    </div>
                    <div className='row' style={{ marginBottom: '12px' }}>

                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="L2 Target"
                                variant="outlined"
                                value={objectDataNew.l2Target}
                                name="l2Target"
                                id="l2Target"
                                type="number"
                                onChange={e => inputChange(e, 'l2Target')}
                                size="small" required={true}
                            />
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="L3 Target"
                                variant="outlined"
                                value={objectDataNew.l3Target}
                                name="l3Target"
                                id="l3Target"
                                type="number"
                                onChange={e => inputChange(e, 'l3Target')}
                                size="small" required={true}
                            />
                        </div>
                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="L5 Target"
                                variant="outlined"
                                value={objectDataNew.l5Target}
                                name="l5Target"
                                id="l5Target"
                                type="number"
                                onChange={e => inputChange(e, 'l5Target')}
                                size="small" required={true}
                            />
                        </div>

                    </div>
                    <div className='row' style={{ marginBottom: '12px' }}>

                        <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                            <InputField
                                label="Battery Target"
                                variant="outlined"
                                value={objectDataNew.batteryTarget}
                                name="batteryTarget"
                                id="batteryTarget"
                                type="text"
                                onChange={e => inputChange(e, 'batteryTarget')}
                                size="small" required={true}
                            />
                        </div>


                    </div>




                    <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                        <div className="col-12 text-center">
                            <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>
                            <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
